import * as http from '../http';

export default {

  isLoggedIn() {
    const session = localStorage.getItem('session');
    if (session) {
      const token = JSON.parse(session).token;
      return !!token;
    }
    return false;
  },

  requireAuth() {
    if (!this.isLoggedIn()) {
      return false;
    }
    return true;
  },

  getSessionToken() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('session')).token;
    }
    return null;
  },

  getSessionFeatures() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('session')).features;
    }
    return null;
  },

  getSession() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('session'));
    }
    return null;
  },

  getRefreshToken() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('refreshToken')).token;
    }
    return null;
  },

  getOrgId() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('session')).orgId;
    }
    return null;
  },

  getUserFullName() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('session')).fullName;
    }
    return null;
  },

  setSession(session) {
    if (session && Object.keys(session).length) {
      localStorage.setItem('session', JSON.stringify({ token: session.token, login: session.login, orgId: session.orgId, features: session.features, fullName: session.fullName }));
      if (JSON.parse(localStorage.getItem('session')) && JSON.parse(localStorage.getItem('session')).token === session.token) {
        return true;
      }
    }
    return false;
  },

  setSessionRefreshToken(token) {
    if (token && token.length) {
      localStorage.setItem('refreshToken', JSON.stringify({ token }));
      if (JSON.parse(localStorage.getItem('refreshToken')) && JSON.parse(localStorage.getItem('refreshToken')).token === token) {
        return true;
      }
    }
    return false;
  },

  setSessionUserNeedFinalization(boolean) {
    localStorage.setItem('userNeedFinalization', boolean);
  },

  getSessionUserNeedFinalization() {
    if (this.isLoggedIn()) {
      return JSON.parse(localStorage.getItem('userNeedFinalization'));
    }
    return null;
  },

  getCASConf() {
    return http.HTTP_CONF.get('/front_conf.json')
      .then(response => response.data);
  },

  CASLogin(items) {
    const params = JSON.parse(atob(items.jsonUserDatas));
    this.setSession({
      token: items.authorization,
      login: params.login,
      orgId: params.userOrgId,
      fullName: `${params.firstName} ${params.name}`,
      features: params.features,
    });
    this.setSessionRefreshToken(items.refreshToken);
    if (this.isLoggedIn()) {
      http.HTTP_ORGANIZATIONS.defaults.headers.common.Authorization = `Bearer ${this.getSessionToken()}`;
      http.HTTP_CAMPAIGNS.defaults.headers.common.Authorization = `Bearer ${this.getSessionToken()}`;
      http.HTTP_DESKRH.defaults.headers.common.Authorization = `Bearer ${this.getSessionToken()}`;
      http.HTTP_USERS.defaults.headers.common.Authorization = `Bearer ${this.getSessionToken()}`;
      http.HTTP_DOCUMENTS.defaults.headers.common.Authorization = `Bearer ${this.getSessionToken()}`;

      http.HTTP_ORGANIZATIONS.defaults.headers.common['Refresh-Token'] = this.getRefreshToken();
      http.HTTP_CAMPAIGNS.defaults.headers.common['Refresh-Token'] = this.getRefreshToken();
      http.HTTP_DESKRH.defaults.headers.common['Refresh-Token'] = this.getRefreshToken();
      http.HTTP_USERS.defaults.headers.common['Refresh-Token'] = this.getRefreshToken();
      http.HTTP_DOCUMENTS.defaults.headers.common['Refresh-Token'] = this.getRefreshToken();
    }
  },

  logout() {
    // http.HTTP_DESKRH.post('/desk-daf-user/logout');
    localStorage.removeItem('session');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userNeedFinalization');
  },
};



// WEBPACK FOOTER //
// ./src/utils/auth.js